import type { CourierData } from '@/apis/lookup';

/** Aligns with backend active company couriers: Basic Tracking + full link. */
function isActiveQuickStatCourier(c: CourierData): boolean {
  return (
    (c.status === 'linked' || c.status === 'basic') &&
    /quickstat/i.test(c.courier_name)
  );
}

export function filterQuickStatCompanyCouriers(
  couriers: CourierData[]
): CourierData[] {
  return couriers.filter(isActiveQuickStatCourier);
}

export function hasQuickStatCompanyCourier(couriers: CourierData[]): boolean {
  return couriers.some(isActiveQuickStatCourier);
}
